[
  {
    "id": "rr_order_1001",
    "order_number": "ORD-1001",
    "status": "in_transit",
    "customer_id": "rr_customer_501",
    "customer_name": "Acme Foods Inc.",
    "pickup_location": { "name": "Acme Warehouse A", "address_line_1": "1200 Industrial Ave", "city": "Chicago", "state": "IL", "postal_code": "60601", "country": "US" },
    "delivery_location": { "name": "Distribution Center 9", "address_line_1": "870 Market Street", "city": "Columbus", "state": "OH", "postal_code": "43004", "country": "US" },
    "pickup_date": "2026-05-21",
    "delivery_date": "2026-05-23",
    "carrier_name": "FastLine Logistics",
    "driver_name": "John Smith",
    "equipment_type": "Dry Van",
    "reference_number": "REF-7781",
    "rate": 1850,
    "currency": "USD",
    "created_at": "2026-05-18T10:30:00Z",
    "updated_at": "2026-05-18T12:45:00Z"
  },
  {
    "id": "rr_order_1002",
    "order_number": "ORD-1002",
    "status": "booked",
    "customer_id": "rr_customer_502",
    "customer_name": "Northstar Retail Group",
    "pickup_location": { "name": "Northstar DC", "address_line_1": "44 Port Road", "city": "Newark", "state": "NJ", "postal_code": "07114", "country": "US" },
    "delivery_location": { "name": "Retail Hub 21", "address_line_1": "2000 Commerce Way", "city": "Pittsburgh", "state": "PA", "postal_code": "15222", "country": "US" },
    "pickup_date": "2026-05-22",
    "delivery_date": "2026-05-24",
    "carrier_name": "Riverbend Freight",
    "driver_name": "Maria Alvarez",
    "equipment_type": "Reefer",
    "reference_number": "REF-7782",
    "rate": 2400,
    "currency": "USD",
    "created_at": "2026-05-18T11:00:00Z",
    "updated_at": "2026-05-18T13:10:00Z"
  },
  {
    "id": "rr_order_1003",
    "order_number": "ORD-1003",
    "status": "delivered",
    "customer_id": "rr_customer_503",
    "customer_name": "Summit Manufacturing",
    "pickup_location": { "name": "Summit Plant", "address_line_1": "910 Foundry Lane", "city": "Detroit", "state": "MI", "postal_code": "48201", "country": "US" },
    "delivery_location": { "name": "Assembly Dock", "address_line_1": "350 Assembly Drive", "city": "Indianapolis", "state": "IN", "postal_code": "46204", "country": "US" },
    "pickup_date": "2026-05-17",
    "delivery_date": "2026-05-19",
    "carrier_name": "Atlas Carrier Co.",
    "driver_name": "Ethan Brown",
    "equipment_type": "Flatbed",
    "reference_number": "REF-7783",
    "rate": 1675,
    "currency": "USD",
    "created_at": "2026-05-16T09:15:00Z",
    "updated_at": "2026-05-19T16:20:00Z"
  },
  {
    "id": "rr_order_1004",
    "order_number": "ORD-1004",
    "status": "dispatched",
    "customer_id": "rr_customer_501",
    "customer_name": "Acme Foods Inc.",
    "pickup_location": { "name": "Cold Storage 4", "address_line_1": "14 Lakefront Blvd", "city": "Milwaukee", "state": "WI", "postal_code": "53202", "country": "US" },
    "delivery_location": { "name": "Grocery Terminal", "address_line_1": "760 Maple Street", "city": "Cleveland", "state": "OH", "postal_code": "44114", "country": "US" },
    "pickup_date": "2026-05-25",
    "delivery_date": "2026-05-26",
    "carrier_name": "FastLine Logistics",
    "driver_name": "Priya Singh",
    "equipment_type": "Reefer",
    "reference_number": "REF-7784",
    "rate": 1325,
    "currency": "USD",
    "created_at": "2026-05-19T08:25:00Z",
    "updated_at": "2026-05-19T10:00:00Z"
  },
  {
    "id": "rr_order_1005",
    "order_number": "ORD-1005",
    "status": "cancelled",
    "customer_id": "rr_customer_504",
    "customer_name": "Blue Harbor Imports",
    "pickup_location": { "name": "Harbor Yard", "address_line_1": "1 Pier Avenue", "city": "Baltimore", "state": "MD", "postal_code": "21202", "country": "US" },
    "delivery_location": { "name": "Inland Depot", "address_line_1": "510 Freight Road", "city": "Richmond", "state": "VA", "postal_code": "23219", "country": "US" },
    "pickup_date": "2026-05-20",
    "delivery_date": "2026-05-21",
    "carrier_name": "Coastal Haulage",
    "driver_name": "Noah Wilson",
    "equipment_type": "Dry Van",
    "reference_number": "REF-7785",
    "rate": 950,
    "currency": "USD",
    "created_at": "2026-05-18T14:00:00Z",
    "updated_at": "2026-05-19T09:40:00Z"
  }
]
